export const categories = [
  {
    name: 'book',
    text: 'Buch',
  },
  {
    name: 'movie',
    text: 'Film',
  },
  {
    name: 'series',
    text: 'Serie',
  },
  {
    name: 'music',
    text: 'Musik',
  },
  {
    name: 'stage',
    text: 'Bühne',
  },
  {
    name: 'exhibition',
    text: 'Ausstellung',
  },
  {
    name: 'festival',
    text: 'Festival',
  },
  {
    name: 'miscellaneous',
    text: 'Sonstiges',
  },
];
